import { Trans } from '@lingui/macro';
import { ActorResponseRuntypeDTO, HistoryOperation } from '@luminovo/http-client';
import { isActorDefined } from '../utils';
import { ActionPerformedBy, TimelineAddIcon, TimelineContentContainer, TimelineEditIcon, TimelineText } from './Utils';

export function AssemblyIcon({ operation }: { operation: HistoryOperation }) {
    if (operation === HistoryOperation.ManualAdd) return <TimelineAddIcon />;
    return <TimelineEditIcon />;
}

type Props = {
    actor: ActorResponseRuntypeDTO;
    assemblyName: string;
    operation: HistoryOperation;
};

function useAssemblyAction(operation: HistoryOperation, actor: ActorResponseRuntypeDTO, assemblyName: string) {
    if (!isActorDefined(actor)) return null;
    switch (operation) {
        case HistoryOperation.ManualAdd:
            return (
                <TimelineText>
                    <Trans>
                        Assembly <b>{assemblyName}</b> created
                    </Trans>{' '}
                    <ActionPerformedBy actor={actor} />
                </TimelineText>
            );
        case HistoryOperation.ManualUpdate:
            return (
                <TimelineText>
                    <Trans>
                        Assembly name changed to <b>{assemblyName}</b>
                    </Trans>{' '}
                    <ActionPerformedBy actor={actor} />
                </TimelineText>
            );
        case HistoryOperation.AutoAdd:
            return (
                <TimelineText>
                    <Trans>
                        The assembly <b>{assemblyName}</b> has been automatically added from the BOM.
                    </Trans>
                </TimelineText>
            );
        case HistoryOperation.AutoGenerate:
            return (
                <TimelineText>
                    {/* we skip the assembly name because it will always be "Automatically generated" */}
                    <Trans>Assembly automatically generated from the BOM</Trans>
                </TimelineText>
            );
        default:
            return null;
    }
}

export default function Assembly({ actor, assemblyName, operation }: Props) {
    const action = useAssemblyAction(operation, actor, assemblyName);
    if (!action) return null;
    return <TimelineContentContainer>{action}</TimelineContentContainer>;
}
